import { memo } from 'react'

/** A plain streamed text block inside the tool list (pre-answer text). */
export const TextPart = memo(function TextPart({ text }: { text: string }) {
  return (
    <div className="flex items-start gap-1.5 py-1.5">
      <span className="mt-[3px] flex h-4 w-3.5 shrink-0 items-center justify-center" aria-hidden="true">
        <span className="bg-element-active h-1.5 w-1.5 rounded-full" />
      </span>
      <span className="text-foreground line-clamp-2 min-w-0 text-left text-[12px] font-medium leading-5">{text}</span>
    </div>
  )
})
